// src/i18n.js
import { createI18n } from "vue-i18n";

const messages = {
  en: {
    footer: {
      title: "READY TO HAVE THE BEST EXPERIENCE \nOF YOUR LIFE?",
      location:
        "Jendral Sudirman Street Pahoman Bandar Lampung, Lampung, 35222",
      phone: "Call us:",
      email: "Email:",
      reserve: "RESERVE A TABLE",
      rights: "All rights reserved © 2025",
    },
    cart: {
      title: "My Cart",
      empty: "Your cart is empty",
      currency: "{amount} LE",
      specialRequest: "Special request",
      specialRequestPlaceholder: "Type your special request....",
      subtotal: "Subtotal",
      serviceFee: "Service fee",
      deliveryFee: "Delivery fee",
      calculatedAtCheckout: "Calculated at check-out",
      grandTotal: "Grand Total",
      continue: "Continue",
      checkout: "Check-Out",
    },
    navbar: {
      menu: "Menu",
      order: "Order",
      aboutUs: "About Us",
      contactUs: "Contact Us",
      bookTable: "BOOK A TABLE ━",
      login: "Login",
      logout: "Logout",
      profile: {
        editProfile: "Edit Profile",
        logout: "Logout",
      },
    },
    homepage: {
      welcome: "Welcome to Tuscany House",
      explore: "Explore the authentic dishes\nwith your loved ones",
      gotoMenu: "GO TO MENU ━",
      specialMenus: "Special Menus",
      todaysSpecial: "Today's Special",
      specialDesc:
        "Special menu oftenly comes different everyday,\nthis is our special food for today",
      quality: "Quality food for you",
      ourMenu: "Our Menu",
      authentic:
        "Authentic food from our restaurant served\nwith high quality ingredients",
      appetizers: "Appetizers",
      homestyle: "Homestyle Sushi",
      steak: "Steak",
      chicken: "Chicken",
      beverages: "Beverages",
      about: "About us",
      story: "Our Story",
      journey:
        "A journey for making successful luxury restaurant\nwith the best services",
      whyChoose: "Why Choose Us?",
      whyDesc:
        "Experience the perfect blend of luxury and comfort in our restaurant. Our chefs use only the finest ingredients to craft dishes that delight your senses.",
      moreAbout: "More about us ━━",
      orderNow: "Order Now",

      dishes: {
        dragonSushiTitle: "Dragon Sushi",
        dragonSushiDesc: "Spicy tuna and avocado topped with eel sauce.",
        dragonSushiPrice: "480 LE",
        steakTartareTitle: "Steak Tartare",
        steakTartareDesc: "Classic raw beef dish with seasoning.",
        steakTartarePrice: "850 LE",
        creamyParmesanTitle: "Creamy Parmesan",
        creamyParmesanDesc: "Chicken breast with creamy parmesan sauce.",
        creamyParmesanPrice: "260 LE",
        sushi1: "Dragon Sushi",
        sushi2: "Creamy Sushi",
        sushi3: "Roll Salmon Sushi",
        ingredients:
          "Ingredients: Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        price: "480 LE",
        salmonRollTitle: "Salmon Roll",
        salmonRollDesc: "Fresh salmon sushi roll with sesame and wasabi mayo.",
      },
      categories: {
        appetizers: {
          tomatoToast: {
            title: "Tomato Toast",
            description: "Fresh tomatoes on artisan bread with herbs",
            price: "120 LE",
          },
          noodleSoup: {
            title: "Noodle Soup",
            description: "Traditional Asian noodle soup with vegetables",
            price: "90 LE",
          },
          pumpkinSoup: {
            title: "Pumpkin Soup",
            description: "Creamy pumpkin soup with seasonal spices",
            price: "90 LE",
          },
        },
        homestyle: {
          dragonSushi: {
            title: "Dragon Sushi",
            description: "Premium sushi with dragon presentation",
            price: "480 LE",
          },
          creamySushi: {
            title: "Creamy Sushi",
            description: "Smooth and creamy sushi rolls",
            price: "250 LE",
          },
          salmonRoll: {
            title: "Salmon Roll",
            description: "Fresh salmon sushi roll",
            price: "360 LE",
          },
        },
        steak: {
          steakTartare: {
            title: "Steak Tartare",
            description: "Premium raw beef with herbs and spices",
            price: "850 LE",
          },
          surfTurf: {
            title: "Surf & Turf",
            description: "Beef and seafood combination",
            price: "700 LE",
          },
          wagyuBeef: {
            title: "Wagyu Beef",
            description: "Premium Japanese beef steak",
            price: "950 LE",
          },
        },
        chicken: {
          creamyParmesan: {
            title: "Creamy Parmesan Chicken",
            description: "Chicken in creamy parmesan sauce",
            price: "260 LE",
          },
          springChicken: {
            title: "Spring Chicken",
            description: "Fresh spring vegetables with chicken",
            price: "300 LE",
          },
          chickenFrancese: {
            title: "Chicken Francese",
            description: "Classic French chicken preparation",
            price: "400 LE",
          },
        },
        beverages: {
          panthouseTonic: {
            title: "Panthouse Tonic",
            description: "Refreshing tonic with citrus notes",
            price: "70 LE",
          },
          appleBreeze: {
            title: "Apple Breeze",
            description: "Fresh apple juice with mint",
            price: "70 LE",
          },
          frenchmanBlitz: {
            title: "Frenchman Blitz",
            description: "French-inspired cocktail blend",
            price: "70 LE",
          },
        },
      },
    },
    about: {
      heroTitle: "Our Story",
      heroSubtitle:
        "A journey for making successful luxury restaurant with the best services.",
      section1: {
        p1: "Welcome to Tuscany House, where every dish is made with heart and served with joy. Founded in 2025, our restaurant was born from a love for food, community, and warm hospitality.",
        p2: "Whether you're here for a quick bite or a special celebration, we aim to make every visit feel like coming home. From our kitchen to your table - thank you for being part of our story.",
        p3: "Our team is dedicated to making every experience special - with friendly service, cozy ambiance, and food that's always fresh and full of flavor.",
      },
      chefsTitle: "Our Chef's",
      chefs: [
        {
          name: "Chef Omar El-Sayed",
          description:
            "At just 22, Chef Omar brings a bold, creative energy to the kitchen. Trained in classic French techniques but inspired by global flavors, he's passionate about turning simple ingredients into unforgettable dishes. His signature style combines modern flair with deep respect for tradition.",
        },
        {
          name: "Chef Mahmoud Youssef",
          description:
            "With over 40 years of culinary experience, Chef Mahmoud is the heart of our kitchen. Known for his patience, precision, and love for authentic home-style cooking, he's mentored generations of chefs and continues to lead with wisdom and passion.",
        },
        {
          name: "Chef Lina Hafez",
          description:
            "A master of balance and elegance, Chef Lina has spent over 10 years refining her craft. Her cooking is known for its harmony of flavors, creative presentation, and a special touch that only experience (and a bit of love) can bring. She's especially celebrated for her desserts and seasonal specialties.",
        },
      ],
    },
    reserved: {
      thank_you: "Thank You!",
      reserved_title: "Your Table Has Been Reserved",
      reserved_description:
        "We've reserved your table and sent a confirmation email with the details – we look forward to welcoming you!",
    },
    login: {
      welcome: "Welcome to the Tuscany House, Login to explore",
      loginForm: {
        login_title: "Login your account!",
        email: "E-mail",
        password: "Password",
        forgot_password: "Forgot password?",
        login_button: "Log In",
        no_account: "Don't have an account?",
        sign_up: "Sign up",
      },
    },
    signup: {
      welcome: "Welcome to the Tuscany House, Sign up to explore",
      signupForm: {
        title: "Create an account!",
        detailsLabel: "Enter your Details",
        username: "Username",
        email: "Email",
        phone: "Phone",
        password: "Password",
        submit: "Sign Up",
        signInWith: "Sign in With",
        or_sign_in_with: "Or Sign in With",
        haveAccount: "Already have an account?",
        login: "Log in",
        agree: "I Agree with Terms of Service and Privacy Policy",
      },
    },
    verifyEmail: {
      title: "Please Verify your Email",
      description:
        "Enter the six digit code we sent to your email address to verify your account",
      button: "Verify Account",
    },
    bookingDuration: {
      breakfast: "Breakfast",
      lunch: "Lunch",
      dinner: "Dinner",
      days: "Sunday - Saturday",
      breakfastTime: "8:00 AM - 12:00 PM",
      lunchTime: "12:00 PM - 6:00 PM",
      dinnerTime: "6:00 PM - 12:00 AM",
    },
    deposit: {
      title: "Confirm your reservation",
      reservationFeeText: "Ready to reserve your table? It's just",
      feeLabel: "Deposit Fee",
      feeAmount: "300.00 LE",
      cardTitle: "Pay by card",
      cardDesc:
        "To pay, please enter your VISA, MasterCard or Maestro payment card information.",
      paymentInfo: "PAYMENT INFORMATION",
      cardNumber: "Card Number",
      expiration: "Expiration date",
      security: "Security code",
      safetyNote:
        "Your payment is 100% safe and secure. We use encryption to protect your data and only work with verified payment gateways. Your trust is a priority for us.",
      continue: "Continue",
      currency: "{amount} LE",
      receipt: {
        title: "TUSCANY HOUSE",
        subtitle: "Deposit Payment Receipt",
        receiptNumber: "Receipt Number:",
        date: "Date:",
        dateAt: "at",
        paymentMethod: "Payment Method:",
        totalAmount: "Total Amount:",
        success: "✅ Deposit Payment Successful!",
        successDesc: "Your deposit has been processed successfully.",
        printReceipt: "Print Receipt",
        goToHome: "Go to Home",
      },
      payment: {
        totalOrder: "Total Order Amount",
        reservationFee: "Reservation Fee",
        preorderTotal: "Pre-order Total",
        paymentMethod: "PAYMENT METHOD",
        creditCard: "Credit/Debit Card",
        cashOnArrival: "Cash on Arrival",
        paymentInformation: "PAYMENT INFORMATION",
        loadingPayment: "Loading secure payment form...",
        processingPayment: "Processing payment...",
        paymentSuccessful: "Payment successful!",
        paymentFailed: "Payment failed. Please try again.",
        securityNote:
          "Your payment information is secure and encrypted. We never store your card details.",
        cashPayment:
          "Cash Payment: You can pay the deposit in cash when you arrive at the restaurant. No payment is required now.",
        continueWithCash: "Continue with Cash Payment",
        payDeposit: "Pay Deposit",
        methods: {
          cash: "Cash",
          card: "Card",
        },
      },
    },
    booking: {
      title: "BOOK A TABLE",
      description:
        "Our dining atmosphere is fancy. To reflect this environment, we maintain a formal dress.",
      name: "Name",
      phone: "Phone Number",
      email: "Email",
      guests: "Number of guests",
      date: "Date",
      next: "NEXT",
      moreThanFour: "For more than 4 guests, please call us.",
    },
    preorder: {
      title: "PRE-ORDER YOUR FOOD",
      subtitle:
        "Plan ahead and pre-order your meal to enjoy faster service and freshly prepared dishes right when you arrive.",
      preorderBtn: "PRE-ORDER ━━",
      arrivalBtn: "NO, I WILL ORDER ON ARRIVAL",
    },
    delivery: {
      title: "My Delivery Orders",
      subtitle: "Track your orders and delivery status",
      loading: "Loading your orders...",
      noOrders: "No Orders Yet",
      noOrdersDesc: "You haven't placed any delivery orders yet.",
      orderNow: "Order Now",
      activeOrders: "Active Orders",
      previousOrders: "Previous Orders",
      orderNumber: "Order",
      deliveryAddress: "Delivery Address",
      paymentMethod: "Payment Method",
      deliveryTime: "Delivered within 45-60 minutes",
      orderItems: "Order Items",
      specialRequest: "Special Request",
      subtotal: "Subtotal",
      serviceFee: "Service Fee",
      total: "Total",
      currency: "{amount} LE",
      delivered: "Delivered",
      paymentMethods: {
        cash: "Cash",
        card: "Card",
        unknown: "Unknown",
      },
      status: {
        preparing: "Preparing",
        outForDelivery: "Out for Delivery",
        delivered: "Delivered",
      },
    },
    contact: {
      title: "Contact Us",
      subtitle:
        "We'd love to hear from you—whether you're inquiring, planning a visit, or booking your next experience.",
      letsTalk: "Let's talk, and we'll take care of the rest.",
      description:
        "Questions, comments, or suggestions? Simply fill in the form and we'll be in touch shortly.",
      workingHours: "Sunday To Saturday",
      workingTime: "8:00 AM To 12:00 AM",
      address:
        "Jendral Sudirman Street Pahoman\nBandar Lampung, Lampung, 35222",
      callUs: "Call us:",
      phone: "+20-100-383-4294",
      email: "Email:",
      form: {
        ok: "OK", 
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Your message...",
        sendMessage: "Send Message",
        sending: "Sending...",
      },
      validation: {
        nameRequired: "Name is required",
        emailRequired: "Email is required",
        invalidEmail: "Please enter a valid email address",
        phoneRequired: "Phone number is required",
        messageRequired: "Message is required",
        messageTooShort: "Message must be at least 10 characters long",
      },
      success: {
        title: "Message Sent!",
        message:
          "Thank you! Your message has been sent successfully. We will get back to you soon.",
      },
      error: {
        title: "Error",
        general: "Error sending message. Please try again.",
        permission: "Permission denied. Please make sure you are logged in.",
        network:
          "Network error. Please check your internet connection and try again.",
        service: "Service temporarily unavailable. Please try again later.",
        validation: "Validation Error",
      },
    },
    cartPage: {
      title: "My Cart",
      subtitle: "Review your items and proceed to checkout",
      emptyCart: {
        ohNo: "OH NO!",
        title: "Your Cart Is Empty!",
        description:
          "Please add items to your cart to complete the check-out process",
        goToMenu: "Go to Menu",
      },
      cartItems: "Cart Items",
      orderSummary: "Order Summary",
      subtotal: "Subtotal",
      serviceFee: "Service fee",
      deliveryFee: "Delivery fee",
      grandTotal: "Grand Total",
      calculatedAtCheckout: "Calculated at check-out",
      continue: "Continue",
      checkout: "Check-Out",
      continueShopping: "Continue Shopping",
      specialRequest: "Special request",
      specialRequestPlaceholder: "type your special request....",
      currency: "{amount} LE",
    },
    checkout: {
      title: "Thank you for your order!",
      orderNumber: "Order #",
      dateAt: "at",
      restaurantName: "Tuscany House",
      restaurantDesc: "Restaurant & Fine Dining",
      orderStatus: "Order Status",
      confirmed: "Confirmed",
      orderDetails: "Order Details",
      quantity: "Qty:",
      deliveryAddress: "Delivery Address",
      specialRequest: "Special Request",
      subtotal: "Subtotal:",
      serviceFee: "Service Fee:",
      deliveryFee: "Delivery Fee:",
      total: "Total:",
      paymentMethod: "Payment Method",
      cashOnDelivery: "Cash on Delivery",
      creditDebitCard: "Credit/Debit Card",
      paymentSuccessfulReceipt: "✓ Payment Successful",
      printReceipt: "Print Receipt",
      backToHome: "Back to Home",
      orderSummary: "Order Summary",
      modify: "Modify",
      inHousePreOrder: "in house pre-order",
      inHousePreOrderHover:
        "If this is an in house pre-order please click here to continue the reservation process",
      deliveryMethod: "Delivery Method",
      deliveryAddressLabel: "Delivery Address:",
      selectOnMap: "Select on Map",
      addAddress: "Add Address",
      addAddressDetails: "Add Address Details",
      city: "City",
      block: "Block",
      streetName: "Street Name",
      buildingName: "Building Name",
      floor: "Floor",
      additionalDetails: "Additional Details",
      preview: "Preview: ",
      addressPreview: "Your address will appear here as you type...",
      save: "Save",
      cancel: "Cancel",
      specialRequestLabel: "Type any special request:",
      specialRequestPlaceholder: "Enter your special request here...",
      submit: "Submit",
      edit: "Edit",
      noSpecialRequest: "No special request entered.",
      paymentSummary: "Payment Summary",
      addNewCard: "Add New Card",
      loadingPayment: "Loading secure payment form...",
      processingPayment: "Processing payment...",
      paymentSuccessful: "Payment successful!",
      paymentFailed: "Payment failed. Please try again.",
      securityNote:
        "Your payment is 100% safe and secure. We use Stripe's secure payment processing to protect your data. Your trust is a priority for us.",
      placeOrder: "Place Order",
      done: "Done",
      currency: "{amount} LE",
    },
    chooseTable: {
      title: "CHOOSE YOUR TABLE",
      subtitle:
        "Please choose your preferred Table from our seating chart to continue the reservation process. Note: the grey out seats are reserved!",
      roundTableMessage:
        "Round tables are only available for 2 guests or less. Please select a square table for larger groups.",
      squareTableMessage:
        "Square tables are only available for 4 guests or less. Please contact us for larger groups.",
      continue: "Continue",
      selected: "Selected: {tableName}",
      tableTypes: {
        square: "Square - 4 seats",
        round: "Round - 2 seats",
      },
    },
    chef: {
      title: "TUSCANY HOUSE - CHEF",
      logout: "Log Out",
      preOrders: "PRE-ORDERS",
      allOrders: "ALL ORDERS",
      todaysOrders: "TODAY'S ORDERS",
      orderType: "Order Type",
      duration: "Duration",
      status: "Status",
      allOrderTypes: "All Order Types",
      allDurations: "All Durations",
      allStatuses: "All Statuses",
      preorder: "Preorder",
      delivery: "Delivery",
      dineIn: "Dine In",
      breakfast: "Breakfast",
      lunch: "Lunch",
      dinner: "Dinner",
      notStarted: "Not Started",
      inProgress: "In Progress",
      readyForDelivery: "Ready for Delivery",
      served: "Served",
      delivered: "Delivered",
      loading: "Loading orders...",
      order: "Order",
      quantity: "Qty",
      specialRequest: "Special Request",
      noOrders: "No orders found",
      noOrdersDesc: "Orders will appear here when customers place them",
      noTodaysOrders: "No orders for today",
      noTodaysOrdersDesc: "No orders have been placed for today yet",
      durations: {
        breakfast: "Breakfast",
        lunch: "Lunch",
        dinner: "Dinner",
      },
    },
    editProfile: {
      title: "Edit Profile",
      subtitle: "Manage your personal information and preferences",
      logout: "Logout",
      profilePictureHint: "Click the edit icon to change your profile picture",
      firstName: "First Name",
      firstNamePlaceholder: "Enter your first name",
      lastName: "Last Name",
      lastNamePlaceholder: "Enter your last name",
      email: "Email Address",
      emailPlaceholder: "Enter your email address",
      emailNote: "Email cannot be changed. Contact support if needed.",
      phone: "Phone Number",
      phonePlaceholder: "Enter your phone number",
      dateOfBirth: "Date of Birth",
      address: "Address",
      addressPlaceholder: "Enter your address",
      deliveryAddress: "Delivery Address",
      deliveryAddressPlaceholder:
        "Enter your delivery address (saved from checkout)",
      deliveryAddressNote:
        "This address is automatically saved when you place delivery orders.",
      preferences: "Preferences",
      favoriteCuisine: "Favorite Cuisine",
      selectCuisine: "Select your favorite cuisine",
      cuisines: {
        italian: "Italian",
        japanese: "Japanese",
        mediterranean: "Mediterranean",
        french: "French",
        american: "American",
        other: "Other",
      },
      dietaryRestrictions: "Dietary Restrictions",
      restrictions: {
        vegetarian: "Vegetarian",
        vegan: "Vegan",
        glutenFree: "Gluten-Free",
      },
      saveChanges: "Save Changes",
      cancel: "Cancel",
      success: "Profile updated successfully!",
      errors: {
        loadError: "Error loading profile data. Please try again.",
        logoutError: "Error logging out. Please try again.",
        uploadError: "Error uploading image. Please try again.",
        loginRequired: "Please log in to save your profile.",
        saveError: "Error saving profile. Please try again.",
      },
    },
    common: {
      loading: "Loading...",
    },
    menu: {
      title: "Our Menu",
      subtitle: "Explore our delicious handcrafted dishes below",
      appetizer: "Appetizers",
      homestyleSushi: "Homestyle Sushi",
      steak: "Steak Dishes",
      chicken: "Chicken Dishes",
      beverages: "Beverages",
      currency: "{amount} LE",
      cart: {
        title: "Your Cart",
        empty: "Your cart is currently empty.",
        total: "Total",
        checkout: "Checkout",
      },
      items: {
        // Appetizers
        tomatoToast: {
          name: "Tomato Toast",
          description: "Fresh tomatoes on toasted sourdough bread.",
        },
        noodleSoup: {
          name: "Noodle Soup",
          description: "Warm and savory noodle broth.",
        },
        pumpkinSoup: {
          name: "Pumpkin Soup",
          description: "Creamy pumpkin soup with seasonal spices.",
        },

        // Sushi
        dragonSushi: {
          name: "Dragon Sushi",
          description: "Spicy tuna and avocado topped with eel sauce.",
        },
        creamySushi: {
          name: "Creamy Sushi",
          description: "Cream cheese roll with crab and cucumber.",
        },
        rollSalmonSushi: {
          name: "Roll Salmon Sushi",
          description: "Salmon roll with sesame and wasabi mayo.",
        },

        // Steak
        steakTartare: {
          name: "Steak Tartare",
          description: "Classic raw beef dish with seasoning.",
        },
        surfTurf: {
          name: "Surf and Turf",
          description: "Grilled steak with shrimp and vegetables.",
        },
        wagyuBeef: {
          name: "Wagyu Beef",
          description: "Premium Japanese Wagyu steak.",
        },

        // Chicken
        creamyParmesan: {
          name: "Creamy Parmesan",
          description: "Chicken breast with creamy parmesan sauce.",
        },
        springChicken: {
          name: "Spring Chicken",
          description: "Light and fresh grilled spring chicken.",
        },
        chickenFrancese: {
          name: "Chicken Francese",
          description: "Lemon-butter chicken with herbs.",
        },

        // Beverages
        panthouseTonic: {
          name: "Panthouse Tonic",
          description: "Tomatillo, Baja Crema, Cabbage, Fried Okra.",
        },
        appleBreeze: {
          name: "Apple Breeze",
          description: "Tomatillo, Baja Crema, Cabbage, Fried Okra.",
        },
        frenchmanBlitz: {
          name: "Frenchman Blitz",
          description: "Tomatillo, Baja Crema, Cabbage, Fried Okra.",
        },
      },
      addToCart: "Add to Cart",
    },
    // Admin Translations
    admin: {
      login: {
        title: "TUSCANY HOUSE ADMIN",
        username: "Admin Username",
        password: "Password",
        usernamePlaceholder: "Enter admin username",
        passwordPlaceholder: "Enter your password",
        loginButton: "Login",
        errorEmpty: "Please enter both username and password",
        errorInvalidUsername: 'Username must contain "admin"',
        errorInvalidCredentials: "Invalid username or password",
      },
      orders: {
        title: "ORDERS",
        searchPlaceholder: "Search orders...",
        filter: "Filter",
        allOrders: "All Orders",
        status: "Status",
        dineIn: "Dine In",
        takeaway: "Takeaway",
        delivery: "Delivery",
        loading: "Loading...",
        ordersFound: "orders found",
        noOrdersFound: "No orders found",
        loadMore: "Load More",
        tableHeaders: {
          orderNumber: "Order#",
          time: "Time",
          customer: "Customer",
          amount: "Amount",
          status: "Status",
          actions: "Actions",
          table: "Table",
          reservation: "Reservation",
        },
        actions: {
          update: "Update",
          delete: "Delete",
        },
        orderDetails: {
          title: "Order Details",
          orderNumber: "Order#",
          date: "Date",
          time: "Time",
          customer: "Customer",
          phone: "Phone",
          orderedItems: "Ordered Items",
          noItemsFound: "No items found",
          subtotal: "Subtotal",
          tax: "Tax",
          total: "Total",
          updateStatus: "Update Status",
          close: "Close",
          export: "Export",
        },
        statuses: {
          pending: "Pending",
          preparing: "Preparing",
          confirmed: "Confirmed",
          cancelled: "Cancelled",
          delivered: "Delivered",
          notStarted: "Not Started",
          inProgress: "In Progress",
          served: "Served",
        },
        confirmDelete: "Are you sure you want to delete this order?",
        editOrder: {
          title: "Edit Order",
          customerInfo: "Customer Information",
          customerName: "Customer Name",
          customerPhone: "Customer Phone",
          customerEmail: "Customer Email",
          orderDetails: "Order Details",
          status: "Status",
          deliveryAddress: "Delivery Address",
          specialRequest: "Special Request",
          paymentInfo: "Payment Information",
          paymentMethod: "Payment Method",
          subtotal: "Subtotal",
          serviceFee: "Service Fee",
          totalAmount: "Total Amount",
          adminNotes: "Admin Notes",
          adminNotesPlaceholder: "Add notes about this update...",
          orderedItems: "Ordered Items",
          addItem: "Add Item",
          dishName: "Dish Name",
          dishSpecialRequest: "Special request for this dish",
          noItems: "No items in this order",
          cancel: "Cancel",
          saveChanges: "Save Changes",
          saving: "Saving...",
          selectFromMenu: "Select dishes from the menu below, or leave empty for custom items"
        },
        types: {
          dineIn: "Dine In",
          takeaway: "Takeaway",
          delivery: "Delivery",
        },
        paymentMethods: {
          cash: "Cash",
          card: "Card",
          online: "Online",
        },
      },
      overview: {
        title: "OVERVIEW",
        summaryCards: {
          occupancy: "Occupancy",
          activeDeliveryOrders: "Active Delivery Orders",
          inHousePreOrders: "In House Pre-Order",
          totalUsers: "Total users",
        },
        latestOrders: "Latest Orders",
        salesPerformance: "Sales Performance",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        yearly: "Yearly",
        revenue: "Revenue",
        orders: "Orders",
        customers: "Customers",
        tableHeaders: {
          customer: "Customer",
          amount: "Amount",
          status: "Status",
          date: "Date",
        },
        noOrdersFound: "No orders found",
        topSellingItems: "Top Selling Items",
        noItemsFound: "No items found",
      },
      messages: {
        title: "MESSAGES",
        searchPlaceholder: "Search messages...",
        messages: "Messages",
        messagesCount: "messages",
        noMessagesFound: "No messages found",
        loadMore: "Load More",
        messageDetails: {
          title: "Message Details",
          name: "Name",
          email: "Email",
          phone: "Phone",
          message: "Message",
          date: "Date",
          status: "Status",
          markAsRead: "Mark as Read",
          markAsUnread: "Mark as Unread",
          delete: "Delete",
          reply: "Reply",
          close: "Close",
        },
        selectMessageToViewDetails: "Select a message to view details",
        adminNotes: "Admin Notes",
        updateStatus: "Update Status",
        markAsReplied: "Mark as Replied",
        replied: "Replied",
        archived: "Archived",
        statuses: {
          read: "Read",
          unread: "Unread",
        },
        confirmDeleteTitle: "Delete Message",
        confirmDeleteText:
          "Are you sure you want to delete this message? This action cannot be undone.",
      },
      common: {
        loading: "Loading...",
        error: "An error occurred",
        noData: "No data found",
        actions: "Actions",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        confirm: "Confirm",
        close: "Close",
        back: "Back",
        next: "Next",
        previous: "Previous",
        search: "Search",
        filter: "Filter",
        export: "Export",
        import: "Import",
        refresh: "Refresh",
        logout: "Log Out",
        profile: "Profile",
        settings: "Settings",
      },
    },
    chatbot: {
      needHelp: "Need help?",
      welcome:
        "Hi! 👋\nHow can I help you today?\nAsk me about our menu, recipes, or anything else!",
      placeholder: "Type your message...",
      restartChat: "Restart chat",
      botTitle: "Tuscany Bot",
      online: "Online",
    },
  },
  ar: {
    footer: {
      title: "هل أنت مستعد لتجربة لا تُنسى؟",
      location: "شارع جنرال سوديرمان، باهومان، \nبندر لامبونج، 35222",
      phone: "اتصل بنا:",
      email: "البريد الإلكتروني:",
      reserve: "احجز طاولتك الآن",
      rights: "جميع الحقوق محفوظة © 2025",
    },
    cart: {
      title: "سلتي",
      empty: "سلتك فارغة",
      currency: "{amount} ج",
      specialRequest: "طلب خاص",
      specialRequestPlaceholder: "اكتب طلبك الخاص....",
      subtotal: "المجموع الفرعي",
      serviceFee: "رسوم الخدمة",
      deliveryFee: "رسوم التوصيل",
      calculatedAtCheckout: "يُحسب عند الدفع",
      grandTotal: "المجموع الكلي",
      continue: "متابعة",
      checkout: "إتمام الطلب",
    },
    navbar: {
      menu: "القائمة",
      order: "طلباتك",
      aboutUs: "من نحن",
      contactUs: "اتصل بنا",
      bookTable: "احجز طاولة\u00A0━",
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
      profile: {
        editProfile: "تعديل الملف الشخصي",
        logout: "تسجيل الخروج",
      },
    },
    homepage: {
      welcome: "مرحبًا بكم في توسكانى هاوس",
      explore: "استمتع بأشهى الأطباق الأصيلة\nمع من تحب",
      gotoMenu: "اذهب إلى القائمة ━",
      specialMenus: "قوائم مميزة",
      todaysSpecial: "عرض اليوم",
      specialDesc:
        "قائمة الطعام الخاصة تتغير يوميًا،\nوهذا هو طعامنا الخاص لهذا اليوم",
      quality: "طعام عالي الجودة من أجلك",
      ourMenu: "قائمتنا",
      authentic: "طعام أصيل من مطعمنا مقدم\nبأعلى جودة من المكونات",
      appetizers: "المقبلات",
      homestyle: "سوشي منزلي",
      steak: "شرائح اللحم",
      chicken: "الدجاج",
      beverages: "المشروبات",
      about: "من نحن",
      story: "قصتنا",
      journey: "رحلة لبناء مطعم فاخر ناجح\nبأفضل الخدمات",
      whyChoose: "لماذا تختارنا؟",
      whyDesc:
        "استمتع بمزيج فاخر من الراحة والفخامة في مطعمنا. يستخدم طهاتنا أفضل المكونات لإعداد أطباق ترضي حواسك.",
      moreAbout: "المزيد عنا ━━",
      orderNow: "اطلب الآن",

      dishes: {
        dragonSushiTitle: "سوشي التنين",
        dragonSushiDesc: "تونة حارة مع أفوكادو وصلصة الإيل.",
        dragonSushiPrice: "480 ج",
        steakTartareTitle: "ستيك تارتار",
        steakTartareDesc: "لحم بقري نيء متبل بالطريقة التقليدية.",
        steakTartarePrice: "850 ج",
        creamyParmesanTitle: "بارميزان كريمي",
        creamyParmesanDesc: "صدر دجاج بصلصة البارميزان الكريمية.",
        creamyParmesanPrice: "260 ج",
        sushi1: "سوشي التنين",
        sushi2: "سوشي كريمي",
        sushi3: "سوشي رول السلمون",
        ingredients:
          "المكونات: لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسكنج إليت.",
        price: "480 ج",
        salmonRollTitle: "رول السلمون",
        salmonRollDesc: "رول سلمون طازج مع سمسم ومايونيز الوسابي.",
      },
      categories: {
        appetizers: {
          tomatoToast: {
            title: "توست بالطماطم",
            description: "طماطم طازجة على خبز محمص مع أعشاب",
            price: "120 ج",
          },
          noodleSoup: {
            title: "شوربة النودلز",
            description: "شوربة نودلز آسيوية تقليدية مع خضروات",
            price: "90 ج",
          },
          pumpkinSoup: {
            title: "شوربة القرع",
            description: "شوربة قرع كريمية مع توابل موسمية",
            price: "90 ج",
          },
        },
        homestyle: {
          dragonSushi: {
            title: "سوشي التنين",
            description: "سوشي فاخر بتقديم التنين",
            price: "480 ج",
          },
          creamySushi: {
            title: "سوشي كريمي",
            description: "رولات سوشي ناعمة وكريمية",
            price: "250 ج",
          },
          salmonRoll: {
            title: "رول السلمون",
            description: "رول سلمون طازج",
            price: "360 ج",
          },
        },
        steak: {
          steakTartare: {
            title: "ستيك تارتار",
            description: "لحم بقري نيء فاخر مع أعشاب وتوابل",
            price: "850 ج",
          },
          surfTurf: {
            title: "سيرف آند تيرف",
            description: "مزيج من اللحم البقري والمأكولات البحرية",
            price: "700 ج",
          },
          wagyuBeef: {
            title: "لحم واجيو",
            description: "ستيك واجيو ياباني فاخر",
            price: "950 ج",
          },
        },
        chicken: {
          creamyParmesan: {
            title: "دجاج بارميزان كريمي",
            description: "دجاج بصلصة البارميزان الكريمية",
            price: "260 ج",
          },
          springChicken: {
            title: "دجاج الربيع",
            description: "خضروات ربيعية طازجة مع الدجاج",
            price: "300 ج",
          },
          chickenFrancese: {
            title: "دجاج فرانشيز",
            description: "تحضير دجاج فرنسي كلاسيكي",
            price: "400 ج",
          },
        },
        beverages: {
          panthouseTonic: {
            title: "بانتهاوس تونيك",
            description: "تونيك منعش بنكهات الحمضيات",
            price: "70 ج",
          },
          appleBreeze: {
            title: "نسيم التفاح",
            description: "عصير تفاح طازج مع النعناع",
            price: "70 ج",
          },
          frenchmanBlitz: {
            title: "فرنشمان بليتز",
            description: "مزيج كوكتيل مستوحى من فرنسا",
            price: "70 ج",
          },
        },
      },
    },
    about: {
      heroTitle: "قصتنا",
      heroSubtitle: "رحلة نحو إنشاء مطعم فاخر يقدّم أفضل الخدمات.",
      section1: {
        p1: "مرحبًا بكم في توسكانى هاوس، حيث يُحضَّر كل طبق بشغف ويُقدَّم بابتسامة. تأسس مطعمنا عام 2025 بدافع حبنا للطعام والمجتمع والضيافة الدافئة.",
        p2: "سواء أتيت لتناول وجبة سريعة أو للاحتفال بمناسبة خاصة، هدفنا أن تشعر وكأنك في بيتك. من مطبخنا إلى مائدتكم – شكرًا لكونكم جزءًا من حكايتنا.",
        p3: "فريقنا يحرص على جعل كل زيارة تجربة مميزة – بخدمة ودودة، وأجواء مريحة، وطعام طازج غني بالنكهات.",
      },
      chefsTitle: "طهاتنا",
      chefs: [
        {
          name: "الشيف عمر السيد",
          description:
            "رغم صغر سنه، إلا أن الشيف عمر 22 عامًا يضفي روحًا إبداعية وشغفًا متجددًا على المطبخ. تلقى تدريبه على الأساليب الفرنسية الكلاسيكية، ويستوحي نكهاته من مطابخ العالم. يجمع في أطباقه بين الحداثة والاحترام العميق للتقاليد.",
        },
        {
          name: "الشيف محمود يوسف",
          description:
            "بخبرة تمتد لأكثر من 40 عامًا، يُعد الشيف محمود العمود الفقري لمطبخنا. يتميز بصبره ودقته وحبه للأكلات المنزلية الأصيلة. خرّج أجيالًا من الطهاة، ولا يزال يقود الفريق بحكمة وشغف.",
        },
        {
          name: "الشيف لينا حافظ",
          description:
            "خبيرة في التوازن والذوق الرفيع، أمضت الشيف لينا أكثر من 10 سنوات في تطوير أسلوبها الفريد. تتميز أطباقها بتناغم النكهات وتقديمها المبتكر، ولمستها الخاصة التي لا تأتي إلا بالخبرة والحب. تُعرف بشكل خاص بحلوياتها ووصفاتها الموسمية.",
        },
      ],
    },
    reserved: {
      thank_you: "شكرا لك",
      reserved_title: "تم حجز طاولتك بنجاح",
      reserved_description:
        "لقد تم تأكيد حجز طاولتك، وتم إرسال رسالة تأكيد إلى بريدك الإلكتروني تحتوي على جميع التفاصيل. نحن بانتظارك بكل سرور!",
    },
    login: {
      welcome: "مرحبا بك في توسكانى هاوس، ابدأ رحلتك معنا بتسجيل الدخول",
      loginForm: {
        login_title: "سجّل دخولك إلى حسابك!",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        forgot_password: "هل نسيت كلمة المرور؟",
        login_button: "تسجيل الدخول",
        no_account: "ليس لديك حساب؟",
        sign_up: "إنشاء حساب",
      },
    },
    signup: {
      welcome: "مرحبًا بك في توسكانى هاوس، سجّل الآن لاستكشاف المزيد",
      signupForm: {
        title: "أنشئ حسابك",
        detailsLabel: "أدخل بياناتك",
        username: "اسم المستخدم",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        password: "كلمة المرور",
        submit: "تسجيل",
        signInWith: "تسجيل الدخول باستخدام",
        or_sign_in_with: "أو سجل الدخول عبر",
        haveAccount: "هل لديك حساب؟",
        login: "تسجيل الدخول",
        agree: "أوافق على شروط الخدمة وسياسة الخصوصية",
      },
    },
    verifyEmail: {
      title: "يرجى التحقق من بريدك الإلكتروني",
      description:
        "أدخل رمز التحقق المكون من 6 أرقام الذي أرسلناه إلى بريدك الإلكتروني لتأكيد الحساب",
      button: "تأكيد الحساب",
    },
    bookingDuration: {
      breakfast: "الإفطار",
      lunch: "الغداء",
      dinner: "العشاء",
      days: "الأحد - السبت",
      breakfastTime: "8:00 ص - 12:00 م",
      lunchTime: "12:00 م - 6:00 م",
      dinnerTime: "6:00 م - 12:00 ص",
    },
    deposit: {
      title: "تأكيد الحجز",
      reservationFeeText: "مستعد لحجز طاولتك؟ مقابل",
      feeLabel: "رسوم الحجز",
      feeAmount: "300.00 ج",
      cardTitle: "ادفع بالبطاقة",
      cardDesc: "يرجى إدخال بيانات بطاقة الدفع (فيزا، ماستركارد، أو مايسترو).",
      paymentInfo: "معلومات الدفع",
      cardNumber: "رقم البطاقة",
      expiration: "تاريخ الانتهاء",
      security: "رمز الأمان",
      safetyNote:
        "دفعك آمن بنسبة 100٪. نستخدم تقنيات التشفير لحماية بياناتك ونتعامل فقط مع بوابات دفع موثوقة. نُقدّر ثقتك ونجعل أمانك أولويتنا.",
      continue: "متابعة",
      currency: "{amount} ج",
      receipt: {
        title: "توسكانى هاوس",
        subtitle: "إيصال دفع الحجز",
        receiptNumber: "رقم الإيصال:",
        date: "التاريخ:",
        dateAt: "عند",
        paymentMethod: "طريقة الدفع:",
        totalAmount: "المبلغ الإجمالي:",
        success: "✅ تم دفع الحجز بنجاح!",
        successDesc: "تم معالجة حجزك بنجاح.",
        printReceipt: "طباعة الإيصال",
        goToHome: "العودة للرئيسية",
      },
      payment: {
        totalOrder: "إجمالي مبلغ الطلب",
        reservationFee: "رسوم الحجز",
        preorderTotal: "رسوم الطلب المسبق",
        paymentMethod: "طريقة الدفع",
        creditCard: "بطاقة الائتمان/الخصم",
        cashOnArrival: "نقداً عند الوصول",
        paymentInformation: "معلومات الدفع",
        loadingPayment: "جاري تحميل نموذج الدفع الآمن...",
        processingPayment: "جاري معالجة الدفع...",
        paymentSuccessful: "تم الدفع بنجاح!",
        paymentFailed: "فشل الدفع. يرجى المحاولة مرة أخرى.",
        securityNote:
          "معلومات الدفع الخاصة بك آمنة ومشفرة. نحن لا نخزن تفاصيل بطاقتك أبداً.",
        cashPayment:
          "دفع نقدي: يمكنك دفع الحجز نقداً عند وصولك للمطعم. لا يلزم دفع أي مبلغ الآن.",
        continueWithCash: "المتابعة بالدفع النقدي",
        payDeposit: "دفع الحجز",
        methods: {
          cash: "نقداً",
          card: "بطاقة",
        },
      },
    },
    booking: {
      title: "احجز طاولتك",
      description: "أجواء المطعم أنيقة، لذا نرجو الالتزام باللباس الرسمي.",
      name: "الاسم",
      phone: "رقم الهاتف",
      email: "البريد الإلكتروني",
      guests: "عدد الضيوف",
      date: "التاريخ",
      next: "التالي",
      moreThanFour: "للحجز لأكثر من ٤ أشخاص يرجى الاتصال بنا.",
    },
    preorder: {
      title: "اطلب طعامك مسبقًا",
      subtitle:
        "خطط مسبقًا واطلب وجبتك قبل الوصول للاستمتاع بخدمة أسرع وأطباق محضرة طازجة عند وصولك.",
      preorderBtn: "طلب مسبق ━━",
      arrivalBtn: "لا، سأطلب عند الوصول",
    },
    delivery: {
      title: "طلبات التوصيل",
      subtitle: "تتبع طلباتك وحالة التوصيل",
      loading: "جاري تحميل طلباتك...",
      noOrders: "لا توجد طلبات بعد",
      noOrdersDesc: "لم تضع أي طلبات توصيل بعد.",
      orderNow: "اطلب الآن",
      activeOrders: "الطلبات الحالية",
      previousOrders: "الطلبات السابقة",
      orderNumber: "طلب",
      deliveryAddress: "عنوان التوصيل",
      paymentMethod: "طريقة الدفع",
      deliveryTime: "يتم التوصيل خلال 45-60 دقيقة",
      orderItems: "عناصر الطلب",
      specialRequest: "طلب خاص",
      subtotal: "المجموع الفرعي",
      serviceFee: "رسوم الخدمة",
      total: "المجموع الكلي",
      currency: "{amount} ج",
      delivered: "تم التوصيل",
      paymentMethods: {
        cash: "نقداً",
        card: "بطاقة",
        unknown: "غير معروف",
      },
      status: {
        preparing: "قيد التحضير",
        outForDelivery: "خارج للتوصيل",
        delivered: "تم التوصيل",
      },
    },
    contact: {
      title: "اتصل بنا",
      subtitle:
        "نود أن نسمع منك - سواء كنت تستفسر أو تخطط لزيارة أو تحجز تجربتك القادمة.",
      letsTalk: "دعنا نتحدث، وسنعتني بالباقي.",
      description:
        "أسئلة أو تعليقات أو اقتراحات؟ ما عليك سوى ملء النموذج وسنتواصل معك قريباً.",
      workingHours: "الأحد إلى السبت",
      workingTime: "8:00 ص إلى 12:00 ص",
      address: "شارع جنرال سوديرمان، باهومان بندر لامبونج، لامبونج، 35222",
      callUs: "اتصل بنا:",
      phone: "+20-100-383-4294",
      email: "البريد الإلكتروني:",
      form: {
        ok: "حسناً", // Arabic
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        message: "رسالتك...",
        sendMessage: "إرسال الرسالة",
        sending: "جاري الإرسال...",
      },
      validation: {
        nameRequired: "الاسم مطلوب",
        emailRequired: "البريد الإلكتروني مطلوب",
        invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صحيح",
        phoneRequired: "رقم الهاتف مطلوب",
        messageRequired: "الرسالة مطلوبة",
        messageTooShort: "يجب أن تكون الرسالة 10 أحرف على الأقل",
      },
      success: {
        title: "تم إرسال الرسالة!",
        message: "شكراً لك! تم إرسال رسالتك بنجاح. سنتواصل معك قريباً.",
      },
      error: {
        title: "خطأ",
        general: "خطأ في إرسال الرسالة. يرجى المحاولة مرة أخرى.",
        permission: "تم رفض الإذن. يرجى التأكد من تسجيل الدخول.",
        network:
          "خطأ في الشبكة. يرجى التحقق من اتصال الإنترنت والمحاولة مرة أخرى.",
        service: "الخدمة غير متاحة مؤقتاً. يرجى المحاولة مرة أخرى لاحقاً.",
        validation: "خطأ في التحقق",
      },
    },
    cartPage: {
      title: "سلتي",
      subtitle: "راجع عناصرك وتابع إلى الدفع",
      emptyCart: {
        ohNo: "أوه لا!",
        title: "سلتك فارغة!",
        description: "يرجى إضافة عناصر إلى سلتك لإكمال عملية الدفع",
        goToMenu: "اذهب إلى القائمة",
      },
      cartItems: "عناصر السلة",
      orderSummary: "ملخص الطلب",
      subtotal: "المجموع الفرعي",
      serviceFee: "رسوم الخدمة",
      deliveryFee: "رسوم التوصيل",
      grandTotal: "المجموع الكلي",
      calculatedAtCheckout: "يُحسب عند الدفع",
      continue: "متابعة",
      checkout: "إتمام الطلب",
      continueShopping: "مواصلة التسوق",
      specialRequest: "طلب خاص",
      specialRequestPlaceholder: "اكتب طلبك الخاص....",
      currency: "{amount} ج",
    },
    checkout: {
      title: "شكراً لك على طلبك!",
      orderNumber: "طلب رقم",
      dateAt: "عند",
      restaurantName: "توسكانى هاوس",
      restaurantDesc: "مطعم ومأكولات فاخرة",
      orderStatus: "حالة الطلب",
      confirmed: "مؤكد",
      orderDetails: "تفاصيل الطلب",
      quantity: "الكمية:",
      deliveryAddress: "عنوان التوصيل",
      specialRequest: "طلب خاص",
      subtotal: "المجموع الفرعي:",
      serviceFee: "رسوم الخدمة:",
      deliveryFee: "رسوم التوصيل:",
      total: "المجموع الكلي:",
      paymentMethod: "طريقة الدفع",
      cashOnDelivery: "نقداً عند التوصيل",
      creditDebitCard: "بطاقة الائتمان/الخصم",
      paymentSuccessfulReceipt: "✓ تم الدفع بنجاح",
      printReceipt: "طباعة الإيصال",
      backToHome: "العودة للرئيسية",
      orderSummary: "ملخص الطلب",
      modify: "تعديل",
      inHousePreOrder: "طلب مسبق في المطعم",
      inHousePreOrderHover:
        "إذا كان هذا طلب مسبق في المطعم يرجى النقر هنا للمتابعة في عملية الحجز",
      deliveryMethod: "طريقة التوصيل",
      deliveryAddressLabel: "عنوان التوصيل:",
      selectOnMap: "اختر على الخريطة",
      addAddress: "إضافة عنوان",
      addAddressDetails: "إضافة تفاصيل العنوان",
      city: "المدينة",
      block: "الحي",
      streetName: "اسم الشارع",
      buildingName: "اسم المبنى",
      floor: "الطابق",
      additionalDetails: "تفاصيل إضافية",
      preview: "معاينة: ",
      addressPreview: "سيظهر عنوانك هنا أثناء الكتابة...",
      save: "حفظ",
      cancel: "إلغاء",
      specialRequestLabel: "اكتب أي طلب خاص:",
      specialRequestPlaceholder: "اكتب طلبك الخاص هنا...",
      submit: "إرسال",
      edit: "تعديل",
      noSpecialRequest: "لم يتم إدخال طلب خاص.",
      paymentSummary: "ملخص الدفع",
      addNewCard: "إضافة بطاقة جديدة",
      loadingPayment: "جاري تحميل نموذج الدفع الآمن...",
      processingPayment: "جاري معالجة الدفع...",
      paymentSuccessful: "تم الدفع بنجاح!",
      paymentFailed: "فشل الدفع. يرجى المحاولة مرة أخرى.",
      securityNote:
        "دفعك آمن بنسبة 100٪. نستخدم معالجة الدفع الآمنة من Stripe لحماية بياناتك. نُقدّر ثقتك ونجعل أمانك أولويتنا.",
      placeOrder: "إتمام الطلب",
      done: "تم",
      currency: "{amount} ج",
    },
    chooseTable: {
      title: "اختر طاولتك",
      subtitle:
        "يرجى اختيار طاولتك المفضلة من مخطط الجلوس للمتابعة في عملية الحجز. ملاحظة: المقاعد الرمادية محجوزة!",
      roundTableMessage:
        "الطاولات الدائرية متاحة فقط لشخصين أو أقل. يرجى اختيار طاولة مربعة للمجموعات الأكبر.",
      squareTableMessage:
        "الطاولات المربعة متاحة فقط لأربعة أشخاص أو أقل. يرجى الاتصال بنا للمجموعات الأكبر.",
      continue: "متابعة",
      selected: "الطاولة المختارة: {tableName}",
      tableTypes: {
        square: "مربعة - 4 كراسي",
        round: "دائرية - 2 كرسي",
      },
    },
    chef: {
      title: "توسكانى هاوس - الشيف",
      logout: "تسجيل الخروج",
      preOrders: "الطلبات المسبقة",
      allOrders: "جميع الطلبات",
      todaysOrders: "طلبات اليوم",
      orderType: "نوع الطلب",
      duration: "المدة",
      status: "الحالة",
      allOrderTypes: "جميع أنواع الطلبات",
      allDurations: "جميع المدد",
      allStatuses: "جميع الحالات",
      preorder: "طلب مسبق",
      delivery: "توصيل",
      dineIn: "تناول في المطعم",
      breakfast: "الإفطار",
      lunch: "الغداء",
      dinner: "العشاء",
      notStarted: "لم يبدأ",
      inProgress: "قيد التنفيذ",
      readyForDelivery: "جاهز للتوصيل",
      served: "تم التقديم",
      delivered: "تم التوصيل",
      loading: "جاري تحميل الطلبات...",
      order: "طلب",
      quantity: "الكمية",
      specialRequest: "طلب خاص",
      noOrders: "لا توجد طلبات",
      noOrdersDesc: "ستظهر الطلبات هنا عندما يضعها العملاء",
      noTodaysOrders: "لا توجد طلبات لليوم",
      noTodaysOrdersDesc: "لم يتم وضع أي طلبات لليوم بعد",
      durations: {
        breakfast: "الإفطار",
        lunch: "الغداء",
        dinner: "العشاء",
      },
    },
    editProfile: {
      title: "تعديل الملف الشخصي",
      subtitle: "إدارة معلوماتك الشخصية وتفضيلاتك",
      logout: "تسجيل الخروج",
      profilePictureHint: "انقر على أيقونة التعديل لتغيير صورة الملف الشخصي",
      firstName: "الاسم الأول",
      firstNamePlaceholder: "أدخل اسمك الأول",
      lastName: "اسم العائلة",
      lastNamePlaceholder: "أدخل اسم العائلة",
      email: "البريد الإلكتروني",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      emailNote: "لا يمكن تغيير البريد الإلكتروني. اتصل بالدعم إذا لزم الأمر.",
      phone: "رقم الهاتف",
      phonePlaceholder: "أدخل رقم هاتفك",
      dateOfBirth: "تاريخ الميلاد",
      address: "العنوان",
      addressPlaceholder: "أدخل عنوانك",
      deliveryAddress: "عنوان التوصيل",
      deliveryAddressPlaceholder: "أدخل عنوان التوصيل (محفوظ من الدفع)",
      deliveryAddressNote: "يتم حفظ هذا العنوان تلقائياً عند طلب التوصيل.",
      preferences: "التفضيلات",
      favoriteCuisine: "المطبخ المفضل",
      selectCuisine: "اختر مطبخك المفضل",
      cuisines: {
        italian: "إيطالي",
        japanese: "ياباني",
        mediterranean: "متوسطي",
        french: "فرنسي",
        american: "أمريكي",
        other: "آخر",
      },
      dietaryRestrictions: "القيود الغذائية",
      restrictions: {
        vegetarian: "نباتي",
        vegan: "نباتي صرف",
        glutenFree: "خالي من الغلوتين",
      },
      saveChanges: "حفظ التغييرات",
      cancel: "إلغاء",
      success: "تم تحديث الملف الشخصي بنجاح!",
      errors: {
        loadError: "خطأ في تحميل بيانات الملف الشخصي. يرجى المحاولة مرة أخرى.",
        logoutError: "خطأ في تسجيل الخروج. يرجى المحاولة مرة أخرى.",
        uploadError: "خطأ في رفع الصورة. يرجى المحاولة مرة أخرى.",
        loginRequired: "يرجى تسجيل الدخول لحفظ ملفك الشخصي.",
        saveError: "خطأ في حفظ الملف الشخصي. يرجى المحاولة مرة أخرى.",
      },
    },
    common: {
      loading: "جاري التحميل...",
    },
    menu: {
      title: "قائمة الطعام",
      subtitle: "استكشف أطباقنا الشهية والمعدة يدويًا أدناه.",
      appetizer: "المقبلات",
      homestyleSushi: "سوشي منزلي",
      steak: "أطباق الستيك",
      chicken: "أطباق الدجاج",
      beverages: "المشروبات",
      currency: "{amount} ج",
      cart: {
        title: "سلة المشتريات",
        empty: "السلة فارغة حاليًا.",
        total: "الإجمالي",
        checkout: "إتمام الطلب",
      },
      items: {
        // Appetizers
        tomatoToast: {
          name: "توست بالطماطم",
          description: "طماطم طازجة على خبز محمص.",
        },
        noodleSoup: {
          name: "شوربة النودلز",
          description: "مرق نودلز دافئ ولذيذ.",
        },
        pumpkinSoup: {
          name: "شوربة القرع",
          description: "شوربة قرع كريمية مع توابل موسمية.",
        },

        // Sushi
        dragonSushi: {
          name: "سوشي التنين",
          description: "تونة حارة مع أفوكادو وصلصة الإيل.",
        },
        creamySushi: {
          name: "سوشي كريمي",
          description: "رول جبن كريمي مع سلطعون وخيار.",
        },
        rollSalmonSushi: {
          name: "رول السلمون",
          description: "سلمون مع سمسم ومايونيز الوسابي.",
        },

        // Steak
        steakTartare: {
          name: "ستيك تارتار",
          description: "لحم بقري نيء متبل بالطريقة التقليدية.",
        },
        surfTurf: {
          name: "سيرف آند تيرف",
          description: "ستيك مشوي مع جمبري وخضروات.",
        },
        wagyuBeef: {
          name: "لحم واجيو",
          description: "ستيك واجيو ياباني فاخر.",
        },

        // Chicken
        creamyParmesan: {
          name: "بارميزان كريمي",
          description: "صدر دجاج بصلصة البارميزان الكريمية.",
        },
        springChicken: {
          name: "دجاج الربيع",
          description: "دجاج مشوي خفيف ومنعش.",
        },
        chickenFrancese: {
          name: "دجاج فرانشيز",
          description: "دجاج بصلصة الليمون والزبدة.",
        },

        // Beverages
        panthouseTonic: {
          name: "بانتهاوس تونيك",
          description: "توماتيلو، كريمة باجا، كرنب، بامية مقلية.",
        },
        appleBreeze: {
          name: "نسيم التفاح",
          description: "توماتيلو، كريمة باجا، كرنب، بامية مقلية.",
        },
        frenchmanBlitz: {
          name: "فرنشمان بليتز",
          description: "توماتيلو، كريمة باجا، كرنب، بامية مقلية.",
        },
      },
      addToCart: "أضف إلى السلة",
    },
    // Admin Translations
    admin: {
      login: {
        title: "إدارة تاسكاني هاوس",
        username: "اسم المستخدم",
        password: "كلمة المرور",
        usernamePlaceholder: "أدخل اسم المستخدم",
        passwordPlaceholder: "أدخل كلمة المرور",
        loginButton: "تسجيل الدخول",
        errorEmpty: "يرجى إدخال اسم المستخدم وكلمة المرور",
        errorInvalidUsername: 'يجب أن يحتوي اسم المستخدم على "admin"',
        errorInvalidCredentials: "اسم المستخدم أو كلمة المرور غير صحيحة",
      },
      orders: {
        title: "الطلبات",
        searchPlaceholder: "البحث في الطلبات...",
        filter: "تصفية",
        allOrders: "جميع الطلبات",
        status: "الحالة",
        dineIn: "تناول في المطعم",
        takeaway: "طلب خارجي",
        delivery: "توصيل",
        loading: "جاري التحميل...",
        ordersFound: "طلب تم العثور عليه",
        noOrdersFound: "لم يتم العثور على طلبات",
        loadMore: "تحميل المزيد",
        tableHeaders: {
          orderNumber: "رقم الطلب",
          time: "الوقت",
          customer: "العميل",
          amount: "المبلغ",
          status: "الحالة",
          actions: "الإجراءات",
          table: "الطاولة",
          reservation: "الحجز",
        },
        actions: {
          update: "تحديث",
          delete: "حذف",
        },
        orderDetails: {
          title: "تفاصيل الطلب",
          orderNumber: "رقم الطلب",
          date: "التاريخ",
          time: "الوقت",
          customer: "العميل",
          phone: "الهاتف",
          orderedItems: "العناصر المطلوبة",
          noItemsFound: "لم يتم العثور على عناصر",
          subtotal: "المجموع الفرعي",
          tax: "الضريبة",
          total: "الإجمالي",
          updateStatus: "تحديث الحالة",
          close: "إغلاق",
          export: "تصدير",
        },
        statuses: {
          pending: "قيد الانتظار",
          preparing: "يتم التحضير",
          confirmed: "تم التأكيد",
          cancelled: "تم الإلغاء",
          delivered: "تم التوصيل",
          notStarted: "لم يبدأ",
          inProgress: "قيد التنفيذ",
          served: "تم التقديم",
        },
        confirmDelete: "هل أنت متأكد من حذف هذا الطلب؟",
        editOrder: {
          title: "تعديل الطلب",
          customerInfo: "معلومات العميل",
          customerName: "اسم العميل",
          customerPhone: "هاتف العميل",
          customerEmail: "إيميل العميل",
          orderDetails: "تفاصيل الطلب",
          status: "الحالة",
          deliveryAddress: "عنوان التوصيل",
          specialRequest: "طلب خاص",
          paymentInfo: "معلومات الدفع",
          paymentMethod: "طريقة الدفع",
          subtotal: "المجموع الفرعي",
          serviceFee: "رسوم الخدمة",
          totalAmount: "المبلغ الإجمالي",
          adminNotes: "ملاحظات المدير",
          adminNotesPlaceholder: "أضف ملاحظات حول هذا التحديث...",
          orderedItems: "العناصر المطلوبة",
          addItem: "إضافة عنصر",
          dishName: "اسم الطبق",
          dishSpecialRequest: "طلب خاص لهذا الطبق",
          noItems: "لا توجد عناصر في هذا الطلب",
          cancel: "إلغاء",
          saveChanges: "حفظ التغييرات",
          saving: "جاري الحفظ...",
          selectFromMenu: "اختر الأطباق من القائمة أدناه، أو اتركها فارغة للعناصر المخصصة",
        },
        types: {
          dineIn: "تناول في المطعم",
          takeaway: "طلب خارجي",
          delivery: "توصيل",
        },
        paymentMethods: {
          cash: "نقدي",
          card: "بطاقة",
          online: "أونلاين",
        },
      },
      overview: {
        title: "نظرة عامة",
        summaryCards: {
          occupancy: "الإشغال",
          activeDeliveryOrders: "طلبات التوصيل النشطة",
          inHousePreOrders: "الطلبات المسبقة في المطعم",
          totalUsers: "إجمالي المستخدمين",
        },
        latestOrders: "أحدث الطلبات",
        salesPerformance: "أداء المبيعات",
        daily: "يومي",
        weekly: "أسبوعي",
        monthly: "شهري",
        yearly: "سنوي",
        revenue: "الإيرادات",
        orders: "الطلبات",
        customers: "العملاء",
        tableHeaders: {
          customer: "العميل",
          amount: "المبلغ",
          status: "الحالة",
          date: "التاريخ",
        },
        noOrdersFound: "لم يتم العثور على طلبات",
        topSellingItems: "أكثر الطلبات المبيعة",
        noItemsFound: "لم يتم العثور على عناصر",
      },
      messages: {
        title: "الرسائل",
        searchPlaceholder: "البحث في الرسائل...",
        messages: "الرسائل",
        messagesCount: "رسالة",
        noMessagesFound: "لم يتم العثور على رسائل",
        loadMore: "تحميل المزيد",
        messageDetails: {
          title: "تفاصيل الرسالة",
          name: "الاسم",
          email: "البريد الإلكتروني",
          phone: "الهاتف",
          message: "الرسالة",
          date: "التاريخ",
          status: "الحالة",
          markAsRead: "تحديد كمقروء",
          markAsUnread: "تحديد كغير مقروء",
          delete: "حذف",
          reply: "رد",
          close: "إغلاق",
        },
        selectMessageToViewDetails: "اختر رسالة لعرض التفاصيل",
        adminNotes: "ملاحظات الإدارة",
        updateStatus: "تحديث الحالة",
        markAsReplied: "تحديد كرد",
        replied: "رد",
        archived: "مؤرشف",
        statuses: {
          read: "مقروء",
          unread: "غير مقروء",
        },
        confirmDeleteTitle: "حذف الرسالة",
        confirmDeleteText:
          "هل أنت متأكد أنك تريد حذف هذه الرسالة؟ لا يمكن التراجع عن هذا الإجراء.",
      },
      common: {
        loading: "جاري التحميل...",
        error: "حدث خطأ",
        noData: "لم يتم العثور على بيانات",
        actions: "الإجراءات",
        edit: "تعديل",
        delete: "حذف",
        save: "حفظ",
        cancel: "إلغاء",
        confirm: "تأكيد",
        close: "إغلاق",
        back: "رجوع",
        next: "التالي",
        previous: "السابق",
        search: "بحث",
        filter: "تصفية",
        export: "تصدير",
        import: "استيراد",
        refresh: "تحديث",
        logout: "تسجيل الخروج",
        profile: "الملف الشخصي",
        settings: "الإعدادات",
      },
    },
    chatbot: {
      needHelp: "تحتاج مساعدة؟",
      welcome:
        "مرحباً! 👋\nكيف يمكنني مساعدتك اليوم؟\nاسألني عن قائمتنا، وصفاتنا، أو أي شيء آخر!",
      placeholder: "اكتب رسالتك...",
      restartChat: "إعادة تشغيل المحادثة",
      botTitle: "بوت توسكانى",
      online: "متصل",
    },
  },
};

const savedLang = localStorage.getItem("lang") || "en";

const i18n = createI18n({
  locale: savedLang,
  fallbackLocale: "ar",
  legacy: false,
  globalInjection: true,
  messages,
});

export default i18n;
